/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HEADER_VERSIONS } from '../../constants';
import { HeaderMegaMenuData } from '../../page-frame-types/HeaderMegaMenuData';
import { NoDataAvailable } from '../../page-frame-types/NoDataAvailable';
import { AccountManagementContainer } from './components/AccountManagementContainer';
import { ZillowAuthAccountManagement } from './components/ZillowAuthAccountManagement/ZillowAuthAccountManagement';
import { UserNavigationData } from './types/UserNavigationData';
import { Auth0AccountManagement } from './components/Auth0AccountManagement/Auth0AccountManagement';

type AccountManagementProps = {
    version: HEADER_VERSIONS;
    userNavigationData: UserNavigationData | null;
    links: HeaderMegaMenuData | NoDataAvailable;
    zhlHost: string;
    useAuth0: boolean;
    onAuth0SignIn: () => void;
    onAuth0SignOut: () => void;
};

export const AccountManagement: FunctionComponent<AccountManagementProps> = ({
    links,
    version,
    userNavigationData,
    zhlHost,
    useAuth0,
    onAuth0SignIn,
    onAuth0SignOut,
}) => {
    if (useAuth0) {
        return (
            <AccountManagementContainer>
                <Auth0AccountManagement
                    onSignIn={onAuth0SignIn}
                    onSignOut={onAuth0SignOut}
                    userNavigationData={userNavigationData}
                    zhlHost={zhlHost}
                    version={version}
                />
            </AccountManagementContainer>
        );
    }
    return (
        <AccountManagementContainer>
            <ZillowAuthAccountManagement
                zhlHost={zhlHost}
                links={links}
                onSignOut={onAuth0SignOut}
                userNavigationData={userNavigationData}
                version={version}
            />
        </AccountManagementContainer>
    );
};
